import { UIUtilsEjsVariables } from '../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { Scene } from '../../../ui_html/UISceneTypes.ts';
import { UIDAboutSceneController } from './UIDAboutSceneController.ts';
import { UIDCareersSceneController } from './UIDCareersSceneController.ts';
import { UIDCommunitySceneController } from './UIDCommunitySceneController.ts';
import { UIDFAQSceneController } from './UIDFAQSceneController.ts';
import { UIDGiftingSceneController } from './UIDGiftingSceneController.ts';
import { UIDLeaderboardSceneController } from './UIDLeaderboardSceneController.ts';
import { UIDPatchNotesSceneController } from './UIDPatchNotesSceneController.ts';
import { UIDPrivacyPolicySceneController } from './UIDPrivacyPolicySceneController.ts';
import { UIDStoreSceneController } from './UIDStoreSceneController.ts';
import { UIDProfileSceneController } from './UIDProfileSceneController.ts';
import { UIDValuesSceneController } from './UIDValuesSceneController.ts';
import { UIDValuesExamplesSceneController } from './UIDValuesExamplesSceneController.ts';
import { UIDTermsSceneController } from './UIDTermsSceneController.ts';
import { UIDPressKitSceneController } from './UIDPressKitSceneController.ts';
import { UIDRefundPolicySceneController } from './UIDRefundPolicyController.ts';
import { UIDReplaySceneController } from './UIDReplaySceneController.ts';
import { UIDChampionship25SceneController } from './UIDChampionship25SceneController.ts';
import { UIDChampionship26SceneController } from './UIDChampionship26SceneController.ts';
import { UIDMoreSceneController } from './UIDMoreSceneController.ts';
export class UIDiscordSceneController {
    showScene(scene, hash, value) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        switch(scene){
            case Scene.DiscordLeaderboard:
                void this.discordLeaderboardController.show();
                break;
            case Scene.DiscordStore:
                this.discordStoreController.show(hash, value);
                break;
            case Scene.DiscordAbout:
                this.discordAboutController.show();
                break;
            case Scene.DiscordCareers:
                this.discordCareersController.show();
                break;
            case Scene.DiscordChampionship25:
                this.discordChampionship25Controller.show();
                break;
            case Scene.DiscordChampionship26:
                this.discordChampionship26Controller.show();
                break;
            case Scene.DiscordCommunity:
                this.discordCommunityController.show();
                break;
            case Scene.DiscordFAQ:
                this.discordFAQController.show();
                break;
            case Scene.DiscordPrivacyPolicy:
                this.discordPrivacyPolicyController.show();
                break;
            case Scene.DiscordPatchNotes:
                this.discordPatchNotesController.show();
                break;
            case Scene.DiscordProfile:
                this.discordProfileController.show();
                break;
            case Scene.DiscordGifting:
                this.discordGiftingController.show();
                break;
            case Scene.DiscordValues:
                this.discordValuesController.show();
                break;
            case Scene.DiscordValuesExamples:
                this.discordValuesExamplesController.show();
                break;
            case Scene.DiscordTerms:
                this.discordTermsController.show();
                break;
            case Scene.DiscordPressKit:
                this.discordPressKitController.show();
                break;
            case Scene.DiscordRefundPolicy:
                this.discordRefundPolicyController.show();
                break;
            case Scene.DiscordMore:
                this.discordMoreController.show();
                break;
            default:
                throw new Error('Invalid scene');
        }
    }
    hideAllScenes() {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        this.discordLeaderboardController.hide();
        this.discordStoreController.hide();
        this.discordAboutController.hide();
        this.discordCareersController.hide();
        this.discordChampionship25Controller.hide();
        this.discordChampionship26Controller.hide();
        this.discordCommunityController.hide();
        this.discordFAQController.hide();
        this.discordPrivacyPolicyController.hide();
        this.discordPatchNotesController.hide();
        this.discordProfileController.hide();
        this.discordGiftingController.hide();
        this.discordValuesController.hide();
        this.discordValuesExamplesController.hide();
        this.discordTermsController.hide();
        this.discordPressKitController.hide();
        this.discordRefundPolicyController.hide();
        this.discordMoreController.hide();
    }
    constructor(sidebar){
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        this.discordLeaderboardController = new UIDLeaderboardSceneController(sidebar);
        this.discordStoreController = new UIDStoreSceneController(sidebar);
        this.discordAboutController = new UIDAboutSceneController(sidebar);
        this.discordCareersController = new UIDCareersSceneController(sidebar);
        this.discordChampionship25Controller = new UIDChampionship25SceneController(sidebar);
        this.discordChampionship26Controller = new UIDChampionship26SceneController(sidebar);
        this.discordCommunityController = new UIDCommunitySceneController(sidebar);
        this.discordFAQController = new UIDFAQSceneController(sidebar);
        this.discordPrivacyPolicyController = new UIDPrivacyPolicySceneController(sidebar);
        this.discordPatchNotesController = new UIDPatchNotesSceneController(sidebar);
        this.discordProfileController = new UIDProfileSceneController(sidebar);
        this.discordGiftingController = new UIDGiftingSceneController(sidebar);
        this.discordValuesController = new UIDValuesSceneController(sidebar);
        this.discordValuesExamplesController = new UIDValuesExamplesSceneController(sidebar);
        this.discordTermsController = new UIDTermsSceneController(sidebar);
        this.discordPressKitController = new UIDPressKitSceneController(sidebar);
        this.discordRefundPolicyController = new UIDRefundPolicySceneController(sidebar);
        this.discordReplayController = new UIDReplaySceneController();
        this.discordMoreController = new UIDMoreSceneController(sidebar);
    }
}
